export default __webpack_public_path__ + "static/media/safe and secure.9cd95067.png";